import React, { createContext, useContext } from 'react';

interface ThemeContextValue {
  isDark: boolean;
}

const ThemeContext = createContext<ThemeContextValue>({ isDark: false });

export const ThemeContextProvider = ({
  isDark,
  children,
}: {
  isDark: boolean;
  children: React.ReactNode;
}) => <ThemeContext.Provider value={{ isDark }}>{children}</ThemeContext.Provider>;

export const useIsDark = () => useContext(ThemeContext).isDark;
